import * as def from '@/definitions'
import { PathLayer } from './pathLayer'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { Vector2 } from '@/utilityModels/vector2';

export class ObjectLayer extends Layer
{
    public get layerType() : string { return "object"; }

    // オブジェクト位置、サイズ、回転角
    private _objectX : number = 0;
    private _objectY : number = 0;
    private _objectWidth : number = 100;
    private _objectHeight : number = 100;
    private _objectRotate : number = 0;

    public get x() : number
    {
        // 回転後の座標を得る
        return this.getRotatedPosition().x;
    } 
    public set x(x : number)
    {
        // 回転後の座標を得る
        var rotatedX = this.getRotatedPosition().x;
        // セットしたいx座標との差を出す
        var deltaX = x - rotatedX;
        // 移動
        this._objectX += deltaX;
    }

    public get y() : number
    {
        // 回転後の座標を得る
        return this.getRotatedPosition().y;
    } 
    public set y(y : number)
    {
        // 回転後の座標を得る
        var rotatedY = this.getRotatedPosition().y;
        // セットしたいx座標との差を出す
        var deltaY = y - rotatedY;
        // 移動
        this._objectY += deltaY;
    }

    // 回転したポジションを得る。
    private getRotatedPosition() : Vector2
    {
        var vector = new Vector2(this._objectX, this._objectY);
        // 中心で回転する
        return vector.rotateDegrees(this.rotate, this.centerX, this.centerY);
    }

    public get width() : number
    {
        return this._objectWidth;
    }
    public set width(width : number)
    {
        this._objectWidth = width;
    }

    public get height() : number
    {
        return this._objectHeight;
    }
    public set height(height : number)
    {
        this._objectHeight = height;
    }

    public get rotate() : number
    {
        return this._objectRotate;
    }
    public set rotate(rotate : number)
    {
        this._objectRotate = rotate;
    }

    public get originX() : number
    {
        return this._objectX;
    }

    public get originY() : number
    {
        return this._objectY;
    }

    public clone()
    {
        var cloned = new ObjectLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : ObjectLayer)
    {
        layer.width = this.width;
        layer.height = this.height;
        layer.rotate = this._objectRotate;
        layer.x = this.x;
        layer.y = this.y;

        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.objectX = this._objectX;
        jsonObject.objectY = this._objectY;
        jsonObject.objectWidth = this._objectWidth;
        jsonObject.objectHeight = this._objectHeight;
        jsonObject.objectRotate = this._objectRotate;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : Layer
    {
        var layer = new ObjectLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.objectRotate != null) { this._objectRotate = jsonData.objectRotate; }
        if(jsonData.objectWidth != null) { this._objectWidth = jsonData.objectWidth; }
        if(jsonData.objectHeight != null) { this._objectHeight = jsonData.objectHeight; }
        if(jsonData.objectX != null) { this._objectX = jsonData.objectX; }
        if(jsonData.objectY != null) { this._objectY = jsonData.objectY; }

        super.loadParameterFromJson(jsonData);
    }
}